(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post--exhibition"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection--metaobjects"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const variantPicker = document.querySelector("variant-picker");
  const script = variantPicker ? variantPicker.querySelector("script") : null;
  const productJsonElement = document.getElementById("product-json");

  // JSONデータを取得する関数（script があればそちらを優先）
  const getVariantData = () => {
    const sourceEl = (script && script.textContent.trim()) ? script : productJsonElement;
    if (!sourceEl) return null;

    try {
      return JSON.parse(sourceEl.textContent);
    } catch (err) {
      console.error("❌ JSON解析エラー:", err);
      return null;
    }
  };

  const getProductData = () => {
    const sourceEl = productJsonElement;
    if (!sourceEl) return null;

    try {
      return JSON.parse(sourceEl.textContent);
    } catch (err) {
      console.error("❌ JSON解析エラー:", err);
      return null;
    }
  };

  const updateDisplay = (block) => {
    const data = getVariantData();
    if (!data) return;
    if (!data.featured_image) {
      const data2 = getProductData();
      product_featured_image = data2.featured_image?.src || data2.featured_image;
    }else{
      product_featured_image = data.featured_image;
    }
    const title = data.name ? data.name : data.title;
    const image = data.featured_image?.src || product_featured_image;

    const contact = document.querySelector("#product-contact");
    const inquiry = document.querySelector("#price-inquiry");


    if (contact) {
      const nameInput = contact.querySelector(".produst-name");
      if (!nameInput) return;
      nameInput.querySelector("input").value = title;

      const contactBlock = contact.querySelector(".text-block");
      if(!contactBlock) return;

      const existing = contact.querySelector(".product-info");
      if (existing) existing.remove();

      const div = document.createElement("div");
      div.classList.add("product-info");
      div.innerHTML = `
        <img class="product-image" src="${image}" alt="${title}">
        <h2 class="product-title">${title}</h2>
      `;
      contactBlock.insertAdjacentElement("afterend", div);
    }else{
      console.error("❌ #product-contact 要素が見つかりません");
      return;
    }

    if (inquiry) {
      const selectInput = inquiry.querySelector(".select-type select");
      if (!selectInput) return;
      selectInput.disabled = true;
      selectInput[0].value = '商品のお見積もり・お問い合わせ';
      selectInput[0].textContent = '商品のお見積もり・お問い合わせ';
      selectInput.style.border = 'none';
      selectInput.style.opacity = '1';
      selectInput.style.paddingInline = '0';
      selectInput.style.appearance = 'none';
      console.dir(selectInput);

      const nameInput = inquiry.querySelector(".produst-name");
      if (!nameInput) return;
      nameInput.querySelector("input").value = title;

      const inquiryBlock = inquiry.querySelector(".text-block");
      if(!inquiryBlock) return;

      const existing = inquiry.querySelector(".product-info");
      if (existing) existing.remove();

      const div = document.createElement("div");
      div.classList.add("product-info");
      div.innerHTML = `
        <img class="product-image" src="${image}" alt="${title}">
        <h2 class="product-title">${title}</h2>
      `;
      inquiryBlock.insertAdjacentElement("afterend", div);
    }


  };

  updateDisplay();

  const bodyObserver = new MutationObserver(() => {
    const nameInput = document.querySelector("#product-contact").querySelector(".produst-name");
    if (nameInput && !document.querySelector(".product-info")) {
      updateDisplay();
    }
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  if (script) {
    const observer = new MutationObserver(() => {
      console.log("👀 variant JSONが更新されました");
      updateDisplay();
    });

    observer.observe(script, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  // variant-picker の input クリックでも更新（JSON変更トリガー想定）
  const inputs = variantPicker?.querySelectorAll("input") || [];
  inputs.forEach((input) => {
    input.addEventListener("click", () => {
      console.log(`🖱️ ${input.value} が選択されました`);
      setTimeout(updateDisplay, 50); // JSONが書き換わるタイミング待ち
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
